<template>
  <div id="cypher" class="full_layout cypher">

   <!-- <build v-if="!isNull"/> -->
    <div class="exchangeBigList">
      <div class="userTitle">Exchange records</div>
      <div v-if="!isNull">
      <div class="order_list order_list_title">
        <div class="exchangeCard">Card</div>
       <!--  <div class="exchangeType">类别</div> -->
     <!--    <div class="exchangeSeason">赛季</div> -->
        <div class="exchangeCardName">Item</div>
        <!-- <div class="exchangeCardNum">卡号</div> -->
   <!--      <div class="exchangePlayer">球员</div> -->
        <div class="exchangeTime">Exchange date</div>
        <div class="exchangeAddress">Shipping address</div>
        <div class="exchangeStatus">Status</div>
      </div>
      <ul class="exchangeList">
        <li v-for="(item,index) in list" :key="index">
          <div class="exchangeCard">
            <span v-if="item.Status==3" class="expressView" @click="viewExpress('viewexpress',item)">Track shipment</span>
            <el-image class="exchangeImage" :src="item.TitImg+'?imageView2/2/w/350'" fit="fit" :preview-src-list="[item.TitImg]"></el-image>
          </div>
          <!-- <div class="exchangeType">{{item.Series}}</div> -->
         <!--  <div class="exchangeSeason">{{item.Year}}</div> -->
          <div class="exchangeCardName">
            <p>{{item.Title}}</p>
          </div>
         <!--  <div class="exchangeCardNum">{{item.SkuNumber}}</div> -->
         <!--  <div class="exchangePlayer">{{item.Player}}</div> -->
          <div class="exchangeTime">{{item.CreateDate}}</div>
          <div class="exchangeAddress">
            <p>{{item.Country}} {{item.Provice|setProvice}} {{item.AddressDetail}} {{item.ZipCode}} {{item.UserName}} {{item.Mobile}}</p>
          </div>
          <!-- :class="{xxx:jjj==nn,aaa:kkk==mm}" -->
          <div class="exchangeStatus">
            <span class="text_red" v-if="item.Status==1">Unsigned</span>
            <span class="" v-if="item.Status==2">In warehouse</span>
            <span class="text_greed" v-if="item.Status==3">Shipped</span>
            <span class="" v-if="item.Status==4">Completed</span>
          </div>
        </li>
      </ul>
      <pagination :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' />
      </div>
      <nonull type='order' text="No records found" v-if="isNull" />
    <to-express title='Tracking info' :list="viewexpress" :domVisible='dislogType.viewexpress' @closeDialog="closeDialog" v-if="dislogType.viewexpress" />
    </div>
  </div>
</template>
<script>
import { getInfo} from "@/api/public";
import Build from '@/components/build'
import ToExpress from '@/components/dialog/viewexpress'
import Pagination from '@/components/pagination'
import Nonull from '@/components/nonull'
export default {
  name: 'cypher',
  components: { Nonull,Build, Pagination,ToExpress},
  data() {
    return {
      isNull: false,
      userInfo:getInfo(),
      ps: 24, //pagesize
      pi: 1, //pageindex
      list:'',
      viewexpress:'',
      TotalCount: 0,
      dislogType: this.$enumInfo.dislogType,
    }
  },
  filters: {
    setProvice(val){
      // var regex = /(<([^>]+)>)/ig;
      if(val!=null){
        // val=val.replace(regex,'');
        val=val.replace(/\-/g,' ');
        //val=val.replace('&nbsp;','');
      }
      return val
    }
  },
  mounted() {},
  created() {
   this.getExchangeOrdersPageList()
  },
  methods: {
    closeDialog(val, bol) {
      this.dislogType[val] = bol;
    },
    viewExpress(val,data){
      this.viewexpress=data
      this.dislogType[val] = true;
    },
    getExchangeOrdersPageList(){
      let that=this;
      let data={
        MemberId:that.userInfo._id,
        PageIndex:that.pi,
        PageSize:that.ps
      }
      that.$get(that.$interface.GetExchangeOrdersPageList,data).then(res=>{
        if(res.Result!=0){
          if(res.Count>0){
            that.isNull=false;
            that.list=res.Data
          }else{
            that.isNull=true;
          }
        }else{
            that.isNull=true;
              that.$message.error(res.Msg);
        }
      })
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getExchangeOrdersPageList()

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getExchangeOrdersPageList()
    }
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../static/css/user.css";

</style>



// WEBPACK FOOTER //
// src/pages/cypher/index.vue